/*
 * 34vintage – Sanftes Einblenden beim Scrollen (v1)
 * ------------------------------------------------------------
 * - Eingebunden über snippets/34v-reveal.liquid (Theme-Einstellung "Einblenden beim Scrollen").
 * - Progressive Enhancement: Elemente werden NUR per JS versteckt, und nur wenn sie
 *   beim Laden unterhalb des Sichtbereichs liegen. Was "above the fold" ist, bleibt
 *   unangetastet (kein Flackern, kein LCP-Delay). Ohne JS ist alles sichtbar.
 * - Animiert nur opacity + transform (kein Layout-Shift).
 * - Gestaffelt pro Reihe (70 ms, max. 400 ms).
 * - Nachgeladene Inhalte (Filter/AJAX, Empfehlungen, Zuletzt angesehen) via MutationObserver.
 * - prefers-reduced-motion: keine Animation.
 * - Ausgenommen: Header, Drawer, Modals, Plinko-Popup, Reward-Bar, Slideshow/Hero.
 */
(function () {
  'use strict';

  var root = document.documentElement;
  if (!('IntersectionObserver' in window)) return;
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (!root.classList.contains('js-reveal')) return;

  /* Was eingeblendet wird */
  var TARGETS = [
    '.grid-product',             /* Produktkarten: Kollektion, Startseite, Empfehlungen, Zuletzt angesehen */
    '.grid-search',              /* Suchergebnisse */
    '.collection-item',          /* Kollektions-Kacheln */
    '.section-header',           /* Section-Überschriften */
    '.feature-row__item',        /* Bild + Text */
    '.promo-grid__container',    /* Promo-/Banner-Kacheln */
    '.v34-pay', '.v34-delivery', '.v34-trust', '.v34-desc'  /* 34v-Blöcke Produktseite */
  ].join(',');

  /* Was nie animiert wird (Element selbst oder ein Vorfahre) */
  var EXCLUDE = [
    '.site-header', '.header-wrapper', '.header-sticky-wrapper', '[data-section-type="header"]', '[id$="__header"]',
    '.drawer', '.modal', '.site-nav', '.site-nav__dropdown', '.megamenu',
    '#v34p', '.v34p', '.v34p-pill', '.v34r-bar', '.v34-satc',
    '.slideshow-wrapper', '.slideshow', '.hero', '[data-section-type="slideshow"]',
    '.product-single__sticky', '.predictive-search', '.cart__item', '.tool-tip'
  ].join(',');

  var STEP = 70, MAX_DELAY = 400, DURATION = 600;
  var initialDone = false;
  var seen = typeof WeakSet === 'function' ? new WeakSet() : null;

  function isSeen(el) { return seen ? seen.has(el) : el.hasAttribute('data-v34-rv-seen'); }
  function markSeen(el) { if (seen) seen.add(el); else el.setAttribute('data-v34-rv-seen', ''); }

  var io = new IntersectionObserver(onIntersect, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });

  function onIntersect(entries) {
    var shown = entries.filter(function (e) { return e.isIntersecting; });
    if (!shown.length) return;

    /* Nach Position sortieren und pro Reihe staffeln */
    shown.sort(function (a, b) {
      return (a.boundingClientRect.top - b.boundingClientRect.top) || (a.boundingClientRect.left - b.boundingClientRect.left);
    });
    var rowTop = null, idx = 0;
    shown.forEach(function (e) {
      var top = Math.round(e.boundingClientRect.top);
      if (rowTop === null || Math.abs(top - rowTop) > 12) { rowTop = top; idx = 0; } else { idx++; }
      reveal(e.target, Math.min(idx * STEP, MAX_DELAY));
      io.unobserve(e.target);
    });
  }

  function reveal(el, delay) {
    el.style.setProperty('--v34-rv-d', delay + 'ms');
    /* rAF: sicherstellen, dass der versteckte Zustand gemalt wurde */
    requestAnimationFrame(function () {
      el.classList.add('v34-rv-in');
      setTimeout(function () { cleanup(el); }, DURATION + delay + 80);
    });
  }

  function cleanup(el) {
    el.classList.remove('v34-rv', 'v34-rv-in');
    el.style.removeProperty('--v34-rv-d');
    el.setAttribute('data-v34-rv-done', '');
  }

  function inViewport(el) {
    var r = el.getBoundingClientRect();
    var vh = window.innerHeight || root.clientHeight;
    return r.top < vh && r.bottom > 0;
  }

  function prepare(el) {
    if (isSeen(el)) return;
    markSeen(el);
    if (el.closest(EXCLUDE)) return;
    /* Theme-eigene Animation (data-aos, ausser Karten-Reihen) nicht doppeln */
    var aos = el.getAttribute('data-aos');
    if (aos !== null && aos.indexOf('row-of') !== 0) return;
    /* Kein doppeltes Animieren verschachtelter Ziele */
    var p = el.parentElement && el.parentElement.closest(TARGETS);
    if (p && (p.classList.contains('v34-rv') || isSeen(p))) return;
    /* Unsichtbare/leere Elemente überspringen */
    if (!el.offsetWidth && !el.offsetHeight) return;

    if (!initialDone && inViewport(el)) {
      /* Beim Laden schon sichtbar: sofort zeigen, nicht anfassen */
      el.setAttribute('data-v34-rv-done', '');
      return;
    }
    el.classList.add('v34-rv');
    io.observe(el);
  }

  function scan(scope) {
    if (!scope || scope.nodeType !== 1) return;
    if (scope.matches && scope.matches(TARGETS)) prepare(scope);
    var list = scope.querySelectorAll(TARGETS);
    for (var i = 0; i < list.length; i++) prepare(list[i]);
  }

  /* Nachgeladene Inhalte */
  var pending = [], scheduled = false;
  function flush() {
    scheduled = false;
    var nodes = pending; pending = [];
    nodes.forEach(function (n) { if (n.isConnected) scan(n); });
  }
  var mo = new MutationObserver(function (muts) {
    for (var i = 0; i < muts.length; i++) {
      var added = muts[i].addedNodes;
      for (var j = 0; j < added.length; j++) if (added[j].nodeType === 1) pending.push(added[j]);
    }
    if (pending.length && !scheduled) { scheduled = true; requestAnimationFrame(flush); }
  });

  function init() {
    scan(document.body);
    initialDone = true;
    mo.observe(document.body, { childList: true, subtree: true });
    /* Theme-Editor: neu gerenderte Sections erneut scannen */
    document.addEventListener('shopify:section:load', function (e) { scan(e.target); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
